import React, { useEffect, useState } from "react";
import leftArrow from '../../../../assets/icons/arrow-square-left-svgrepo-com.svg';
import rightArrow from '../../../../assets/icons/arrow-square-right-svgrepo-com.svg';
import { usePlayer } from "../../../../Contexts/playerData.context";

const HWSDraftScout = () => {

     const { activePlayer } = usePlayer();
     const [dsdata, setdsdata] = useState([]);
     const [recordNum, setRecordNum] = useState(0);

     useEffect(() => {
          const getDSData = async () => {
               try {
                    const response = await fetch("https://www.fbxchange.com/ReactPHP/hdbox.php", {
                         method: "POST",
                         headers: { "Content-Type": "application/json" },
                         body: JSON.stringify({ FBXID: activePlayer.FBXID, script: "getDraftScout" }),
                    });

                    const data = await response.json();
                    setdsdata(data);

               } catch (error) {
                    console.error("Error fetching data:", error);
               }
          };
          getDSData();
          setRecordNum(0);
     }, [activePlayer]);

     const addToRecord = () => {
          const testNum = dsdata.length - 1;
          if (recordNum < testNum) {
               setRecordNum(recordNum + 1);
          }
     }
     const removeFromRecord = () => {

          if (recordNum > 0) {
               setRecordNum(recordNum - 1);
          }
     }

     const omit = ["DRNUM", "ID", "schoolFound", "cflIgnoreYear","DSTeamID","DSDivisionId","insertCode","whatStep","DRNUM"]
     const subs = [
          {key:"SchoolBioLink", value: "School Link"},
          {key:"playerId", value: "Draft Scout ID"},
          {key:"DSNote", value: "Draft Scout Note"},
          {key:"DSDate", value: "Draft Scout Date"},
          {key:"InjuriesTransfers", value: "Injuries / Transfers"},
          {key:"LastName", value: "Last Name"},
          {key:"FirstName", value: "First Name"},
          {key:"DraftYear", value: "Draft Year"},
          {key:"FBXSchool", value: "FBX School Code"},
          {key:"Time40", value: "Speed"},
          {key:"PositionSpecific", value: "Specific Position"},
          {key:"FBXGenPos", value: "FBX Gen Pos"},
          {key:"Positions2", value: "Position 2"},
          {key:"HighSchoolRecruitingStars", value: "High School Stars"},
          {key:"Early", value: "Early Out Jr."},
          {key:"DSRank", value: "Draft Scout Rank"},
          {key:"Top750", value: "Position Rank"},
          {key:"ProjectedRound", value: "Projected Round"},
          {key:"Stock", value: "Stock Up/Down"},
          {key:"HomeCity", value: "Home Town"},
          {key:"HighSchool", value: "HighSchool"},
          {key:"HomeState", value: "Home State"},
          {key:"NFLGradeNotes", value: "NFL Grade Notes"},
          {key:"AwardAndInjuries", value: "Awards / Injuries"},
          {key:"DSGradeNotes", value: "Draft Scout Grade Notes"},
          {key:"RatingChangeDate", value: "Rating Date Changed"},
          {key:"CombineInvite", value: "Combine Invite"},
          {key:"CombineGroup", value: "Combine Group"},
          {key:"CombineNumber", value: "Combine Jersey"},
          {key:"CombineWONotes", value: "Combine WO Notes "},
          {key:"CombineNotes", value: "Combine Notes "},
          {key:"ProDayDate", value: "Pro Day Date"},
          {key:"ProDayDate2", value: "Second Pro Date"},
          {key:"ProDayInfo", value: "Pro Day Info"},
          {key:"ProDayNotes", value: "Pro Day Notes"},
          {key:"DraftedRound", value: "Drafted Round"},
          {key:"DraftPick", value: "Draft Pick"},
          {key:"OverallDraftPick", value: "Overall Draft Pick"},
          {key:"DraftedBy", value: "Drafted By"},
          {key:"SignDate", value: "Signed Date"},
          {key:"SignedBy", value: "Signed By Team"},
          {key:"Height2", value: "Second Height"},
          {key:"FORTYRangeLow", value: "40 Speed Low"},
          {key:"FORTYRangeHigh", value: "40 Speed High"},
          {key:"searchCode", value: "Search Code"},
     ]

     const getLabel = (key) => {
          const match = subs.find(item => item.key === key);
          return match ? match.value : key;
        };

     return (
          <div className="hd-draft-scout">
               <div className={`d-flex align-items-center hd-draft-scout__header ${dsdata.length > 0 ? 'alert-navy' : 'alert-warning'}`}>
                    {dsdata && dsdata.length > 0 ?
                         (
                              <div id="yesData" className="w-100 d-flex align-items-center">
                                   <div className="col-5">
                                        <div className={`btn ${recordNum === 0 ? 'btn-secondary' : 'btn-navy'}`}>
                                             <img src={leftArrow} height="32" alt="" onClick={() => removeFromRecord()} />
                                        </div>
                                   </div>
                                   <div className="flex-grow-1 text-center">
                                        Displaying Record {recordNum + 1} of {dsdata.length}
                                   </div>
                                   <div className="col-5 text-end">
                                   <div className={`btn ${recordNum > dsdata.length-2  ? 'btn-secondary' : 'btn-navy'}`}>
                                             <img src={rightArrow} height="32" alt="" onClick={() => addToRecord()} />
                                        </div>
                                   </div>
                              </div>
                         ) : (
                              <div id="noData" className="d-flex justify-content-center align-items-center w-100 p-3">
                                   <div className="fs-9 text-center">
                                        There are No Draft Scout History Records found for this player
                                   </div>
                              </div>
                         )}
               </div>
               {dsdata && dsdata[recordNum] && (
                    <div className="w-100 hd-draft-scout__body">
                         <div className="w-100" style={{ overflowY: "auto", maxHeight: "500px" }}>
                              {Object.entries(dsdata[recordNum])
                                   .filter(([key]) => !omit.includes(key))
                                   .map(([key, value], index) => (
                                        <div key={index} className="d-flex justify-content-between border-bottom py-1 hd-draft-scout__row">
                                             <div className="fw-bold col-9 text-end">{getLabel(key)}</div>
                                             <div className="flex-grow-1 px-3">
                                                  {key === "SchoolBioLink" ? (
                                                       <a href={value} target="_blank" rel="noopener noreferrer">{value}</a>
                                                  ) : (
                                                       value
                                                  )}
                                             </div>
                                        </div>
                                   ))}
                         </div>

                    </div>
               )}
          </div>
     );
};

export default HWSDraftScout;
